"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replace = void 0;
const findRoot_1 = require("./findRoot");
const replace = (into, at, what) => {
    const mergeIdx = into.nodes.length;
    const merged = {
        nodes: into.nodes.map((node) => ({ ...node })),
        contents: [...into.contents],
        definitions: { ...into.definitions },
        footnotes: { ...into.footnotes },
        footnoteOrder: [],
    };
    const replacedNode = merged.nodes[at];
    merged.nodes[at] = {
        type: 'portal',
        idx: at,
        parent: replacedNode.parent,
        original: replacedNode,
        children: [mergeIdx],
    };
    // APPEND NODES.
    for (const node of what.nodes) {
        const newNode = {
            ...node,
            idx: node.idx + mergeIdx,
            parent: node.parent + mergeIdx,
        };
        if (newNode.children) {
            newNode.children = newNode.children.map((idx) => idx + mergeIdx);
        }
        merged.nodes.push(newNode);
    }
    // PROCESS MERGED IN ROOT
    const mergedRoot = merged.nodes[mergeIdx];
    mergedRoot.parent = at;
    mergedRoot.depth = (into.nodes[(0, findRoot_1.findRoot)(into, at)].depth || 0) + 1;
    // MERGE METADATA.
    for (const idx of what.contents) {
        merged.contents.push(idx + mergeIdx);
    }
    for (const identifier of Object.keys(what.definitions)) {
        merged.definitions[identifier] = what.definitions[identifier] + mergeIdx;
    }
    // MERGE FOOTNOTES.
    for (const identifier of Object.keys(what.footnotes)) {
        merged.footnotes[identifier] = what.footnotes[identifier] + mergeIdx;
    }
    for (const node of merged.nodes)
        if (node.type === 'footnoteDefinition')
            node.cnt = 0;
    let footnoteCounter = 0;
    for (const node of merged.nodes) {
        if (node.type === 'footnoteReference' || node.type === 'imageReference') {
            const definition = merged.nodes[merged.footnotes[node.identifier]];
            if (!definition.cnt) {
                definition.cnt = ++footnoteCounter;
                merged.footnoteOrder.push(definition.idx);
            }
        }
    }
    return merged;
};
exports.replace = replace;
